import Axios, { AxiosHeaders, InternalAxiosRequestConfig } from 'axios';
//import { API_URL } from 'src/config';

// Funci�n para obtener el token (puede ser de localStorage o donde lo guardes)
async function getToken(): Promise<string | null> {
  return localStorage.getItem('token');
}

// Interceptor para agregar el token a las solicitudes
async function authRequestInterceptor(config: InternalAxiosRequestConfig): Promise<InternalAxiosRequestConfig> {
  const token = await getToken();
  if (!config.headers) { config.headers = new AxiosHeaders(); }

  if (token) {
    config.headers.authorization = `Bearer ${token}`;
  }
  config.headers.Accept = 'application/json';
  return config;
}

// Crear la instancia de axios
export const axios = Axios.create(/*{ baseURL: API_URL, }*/);

// A�adir el interceptor a las solicitudes
axios.interceptors.request.use(authRequestInterceptor);

// A�adir el interceptor para las respuestas
axios.interceptors.response.use(
  (response) => response.data,  // Enviar solo `data` en respuestas exitosas
  (error) => {
    throw error;  // Lanza errores para que sean capturados por `react-query`
  }
);
